<template>
  <div class="flex">
    <div class="tag-row-label">
      Traffic Types
      <span class="text-xxs font-normal block">Select Allowed Types</span>
    </div>

    <div class="flex w-full grid grid-cols-4">
      <div v-for="tag in trafficTags" :key="tag.id" class="w-full">
        <YCheckbox
          :id="tag.name"
          :value="!restrictedTagNames.includes(tag.name)"
          @input="value => updateTag(value, tag.name)"
          :label="tag.name"
          :inline="true"
          class="flex items-center mr-2"
          type="info"
        ></YCheckbox>
      </div>
    </div>
    <div :class="{ invisible: !hasChanged }">
      <YButton
        @click="upsertTags"
        color="blue"
        class="mt-4"
        :isLoading="isUpdating"
        >Update Tags</YButton
      >
    </div>
  </div>
</template>

<script>
import TAGS_QUERY from '@/graphql/Tag/TagsQuery.gql'
import SYNC_TAGS_WITH_TYPE_MUTATION from '@/graphql/Tag/SyncTagsWithTypeMutation.gql'

export default {
  props: {
    campaign: {
      type: Object,
      required: true
    },
    tagType: {
      type: String
    }
  },
  apollo: {
    trafficTags: {
      query: TAGS_QUERY,
      variables() {
        return {
          first: 999,
          filters: {
            type: { value: ['trafficType'] }
          }
        }
      },
      update: data => data.tags.data
    }
  },
  data() {
    return {
      TAGS_QUERY,
      tagsSelected: {},
      isUpdating: false,
      restrictedTags: [],
      allowedTags: [],
      initialRestrictedTagNames: []
    }
  },
  computed: {
    trafficTagsByName() {
      return this.mapByField(this.trafficTags ?? [], 'name')
    },
    restrictedTagNames() {
      return this.restrictedTags.map(tag => tag.name)
    },
    hasChanged() {
      const current = [...this.restrictedTagNames].sort()
      const initial = this.initialRestrictedTagNames

      return !current.every((item, index) => item === initial[index])
    }
  },
  watch: {
    campaign: {
      handler(campaign) {
        let restricted = campaign.tags.filter(
          tag => tag.type == this.tagType && tag.isNot == true
        )
        this.restrictedTags = restricted
        this.initialRestrictedTagNames = restricted.map(tag => tag.name).sort()
      },
      immediate: true
    }
  },
  methods: {
    updateTag(value, name) {
      if (value == true) {
        this.restrictedTags = this.restrictedTags.filter(
          tag => tag.name != name
        )
        return
      }

      this.restrictedTags.push(this.trafficTagsByName[name])
    },
    upsertTags() {
      this.isUpdating = true

      this.$apollo
        .mutate({
          mutation: SYNC_TAGS_WITH_TYPE_MUTATION,
          variables: {
            input: {
              detachMode: 'SAME_POLARITY',
              isNot: true,
              taggableId: this.campaign.id,
              type: this.tagType,
              taggableType: 'campaign',
              tags: this.restrictedTagNames
            }
          }
        })
        .then(() => {
          this.isUpdating = false
          this.initialTagsJson = null //!
        })
    },
    mapByField(array, field) {
      return array.reduce((acc, item) => {
        if (item[field] !== undefined) {
          acc[item[field]] = item
        }
        return acc
      }, {})
    }
  }
}
</script>

<style>
.tag-row-label {
  @apply w-48 text-left px-4 font-bold text-gray-700
  flex flex-col;
  min-width: 12rem;
}
</style>
